<template>
    <add-edit-question></add-edit-question>
</template>

<script>

import vSelect from "vue-select";
import AddEditQuestion from "@/layouts/components/questionnaire/addedit-question.vue";

export default {
 components : {
   AddEditQuestion
 },
};
</script>